import 'css-chunksrc/client/scenes/wbs/dateForm/styles.scss';export default {
  "dateForm": "_dateForm_1qyyi_1",
  "input": "_input_1qyyi_5",
  "readOnly": "_readOnly_1qyyi_12",
  "recalculated": "_recalculated_1qyyi_18",
  "disabled": "_disabled_1qyyi_23"
};